App.DishAvailabilityItemComponent = Em.Component.extend
  readonly: false

  restaurantName: (->
    restaurant = @get('restaurants').find (restaurant) =>
      parseInt(restaurant.get('id')) == @get('availability.restaurant_id')
    restaurant.get('name')
  ).property('availability.restaurant_id', 'restaurants')

  isNotAvailable: ((key, value) ->
    value = value + ''

    if arguments.length > 1
      switch @get('availability.status')
        when 'available'     then @set('availability.status', 'not_available')
        when 'call'          then @set('availability.status', 'not_available')
        when 'not_available' then @set('availability.status', 'available')

      @sendAction('onAvailabilityChanged')

    @get('availability.status') == 'not_available'

  ).property('availability.status')

  doesRequireCall: ((key, value) ->
    value = value + ''

    if arguments.length > 1
      switch @get('availability.status')
        when 'available'     then @set('availability.status', 'call')
        when 'call'          then @set('availability.status', 'available')
        when 'not_available' then @set('availability.status', 'call')

      @sendAction('onAvailabilityChanged')

    @get('availability.status') == 'call'
  ).property('availability.status')


